import { createAirtableRecord } from "@/utils/apis/airtable-service";
import { useAuthStore } from "@/utils/stores/useAuthStore";
import { useState } from "react";
import { RecordPayload } from "../types/ItemPayload";

export const useCreateAirtableRecord = () => {
    const { auth } = useAuthStore()
    const idToken = auth.idToken

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [data, setData] = useState<any>(null);

    const create = async (item: RecordPayload, onSuccess?: (data: any) => void) => {
        if (!idToken) return
        setLoading(true);
        setError(null);
        const response = await createAirtableRecord(idToken, item);
        setLoading(false);

        if (response.success) {
            setData(response.data);
            onSuccess?.(response.data);
        } else {
            setError(response.error);
        }
    };

    return { create, loading, error, data };
}